// Reads the JWT stored at login (see authController.js's `token` field,
// saved into localStorage as part of the `user` object) and returns it as
// a fetch-ready headers object. Spread this into any fetch() call that
// hits an endpoint using getRequestUser()/permission checks on the
// backend (quotation_service.js: getRFQById, updateRFQ, internalDecision,
// customerDecision, etc.) — without it, req.user is never populated and
// every backend permission check silently no-ops (fails open).
//
// Usage: fetch(url, { headers: { "Content-Type": "application/json", ...authHeaders() } })
export const authHeaders = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.token ? { Authorization: `Bearer ${user.token}` } : {};
  } catch (e) {
    console.error("authHeaders: failed to read token from localStorage", e);
    return {};
  }
};